<template>
  <div class="flex space-x-1">
    <CoreButtonBase
      v-bind="$attrs"
      @click="emit('click')"
      :type="type"
      :disabled="disabled"
      :loading="loading"
      class="rounded-r-none"
    >
      <slot />
    </CoreButtonBase>
    <Menu
      :class="[
        loading && 'pointer-events-none opacity-70',
        disabled && 'pointer-events-none',
      ]"
      :position="position"
    >
      <CoreButtonBase
        class="rounded-l-none px-1"
        withIcon
        :type="type"
        :disabled="disabled"
      >
        <CoreIcon icon-id="ellipses" size="xs" rotate="90" />
      </CoreButtonBase>

      <template #content>
        <slot name="menu" />
      </template>
    </Menu>
  </div>
</template>

<script lang="ts" setup>
import CoreButtonBase from './CoreButtonBase.vue'

type ButtonType = 'primary' | 'secondary' | 'tertiary'
type Position = 'top' | 'right' | 'bottom' | 'left'

const emit = defineEmits<{
  click: []
}>()

const {
  disabled,
  loading,
  position,
  type = 'primary',
} = defineProps<{
  type?: ButtonType
  disabled?: boolean
  loading?: boolean
  position?: Position
}>()
</script>

<style lang="scss" scoped></style>
